import { render, staticRenderFns } from "./WF12_Contact.vue?vue&type=template&id=0f55ead4"
import script from "./WF12_Contact.vue?vue&type=script&lang=js"
export * from "./WF12_Contact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports